export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAIL = "LOGIN_FAIL"
export const LOGOUT = "LOGOUT"
export const SET_PROFILE = "SET_PROFILE"


export const HOME_VIDEOS_REQUEST = "HOME_VIDEOS_REQUEST"
export const HOME_VIDEOS_SUCCESS = "HOME_VIDEOS_SUCCESS"
export const HOME_VIDEOS_FAILED = "HOME_VIDEOS_FAILED"

export const SET_ACTIVE_CATEGORY = "SET_ACTIVE_CATEGORY"


export const SELECTED_VIDEO_REQUEST = "SELECTED_VIDEO_REQUEST"
export const SELECTED_VIDEO_SUCCESS = "SELECTED_VIDEO_SUCCESS"
export const SELECTED_VIDEO_FAILED = "SELECTED_VIDEO_FAILED"

export const LIKED_VIDEOS_REQUEST = "LIKED_VIDEOS_REQUEST"
export const LIKED_VIDEOS_SUCCESS = "LIKED_VIDEOS_SUCCESS"
export const LIKED_VIDEOS_FAILED = "LIKED_VIDEOS_FAILED"

export const RELATED_VIDEOS_REQUEST = "RELATED_VIDEOS_REQUEST"
export const RELATED_VIDEOS_SUCCESS = "RELATED_VIDEOS_SUCCESS"
export const RELATED_VIDEOS_FAILED = "RELATED_VIDEOS_FAILED"

export const SEARCHED_VIDEOS_REQUEST = "SEARCHED_VIDEOS_REQUEST"
export const SEARCHED_VIDEOS_SUCCESS = "SEARCHED_VIDEOS_SUCCESS"
export const SEARCHED_VIDEOS_FAILED = "SEARCHED_VIDEOS_FAILED"

export const SUBSCRIPTIONS_VIDEOS_REQUEST = "SUBSCRIPTIONS_VIDEOS_REQUEST"
export const SUBSCRIPTIONS_VIDEOS_SUCCESS = "SUBSCRIPTIONS_VIDEOS_SUCCESS"
export const SUBSCRIPTIONS_VIDEOS_FAILED = "SUBSCRIPTIONS_VIDEOS_FAILED"

export const SET_COMMENTS = "SET_COMMENTS"
export const SET_COMMENTS_ERRORS = "SET_COMMENTS_ERRORS"

export const CREATE_COMMENT_REQUEST = "CREATE_COMMENT_REQUEST"
export const CREATE_COMMENT_SUCCESS = "CREATE_COMMENT_SUCCESS"
export const CREATE_COMMENT_FAILED = "CREATE_COMMENT_FAILED"

export const CHANNEL_DETAILS_REQUEST = "CHANNEL_DETAILS_REQUEST"
export const CHANNEL_DETAILS_SUCCESS = "CHANNEL_DETAILS_SUCCESS"
export const CHANNEL_DETAILS_FAIL = "CHANNEL_DETAILS_FAIL"

export const CHANNEL_VIDEOS_REQUEST = "CHANNEL_VIDEOS_REQUEST"
export const CHANNEL_VIDEOS_SUCCESS = "CHANNEL_VIDEOS_SUCCESS"
export const CHANNEL_VIDEOS_FAIL = "CHANNEL_VIDEOS_FAIL"

export const RATE_VIDEO_REQUEST = "RATE_VIDEO_REQUEST"
export const RATE_VIDEO_SUCCESS = "RATE_VIDEO_SUCCESS"
export const RATE_VIDEO_FAIL = "RATE_VIDEO_FAIL"

export const CHANNEL_SUBSCRIPTION_STATUS = "CHANNEL_SUBSCRIPTION_STATUS"